/**
 * Typed re-exports of react-icons/hi for React 19 compatibility.
 * react-icons types return ReactNode; React 19 JSX expects Element | null.
 */
import type { ComponentType, SVGAttributes } from 'react';
import * as Hi from 'react-icons/hi';
import * as Fa from 'react-icons/fa';

type IconProps = SVGAttributes<SVGElement> & { size?: number; className?: string };

export const HiX = Hi.HiX as ComponentType<IconProps>;
export const HiCloudUpload = Hi.HiCloudUpload as ComponentType<IconProps>;
export const HiClock = Hi.HiClock as ComponentType<IconProps>;
export const HiLocationMarker = Hi.HiLocationMarker as ComponentType<IconProps>;
export const HiDeviceMobile = Hi.HiDeviceMobile as ComponentType<IconProps>;
export const HiFlag = Hi.HiFlag as ComponentType<IconProps>;
export const HiSpeakerphone = Hi.HiSpeakerphone as ComponentType<IconProps>;
export const HiOfficeBuilding = Hi.HiOfficeBuilding as ComponentType<IconProps>;
export const HiChartBar = Hi.HiChartBar as ComponentType<IconProps>;
export const HiShoppingCart = Hi.HiShoppingCart as ComponentType<IconProps>;
export const HiCreditCard = Hi.HiCreditCard as ComponentType<IconProps>;
export const HiNewspaper = Hi.HiNewspaper as ComponentType<IconProps>;
export const HiCube = Hi.HiCube as ComponentType<IconProps>;
export const HiHome = Hi.HiHome as ComponentType<IconProps>;
export const HiCheckCircle = Hi.HiCheckCircle as ComponentType<IconProps>;
export const HiEye = Hi.HiEye as ComponentType<IconProps>;
export const HiCursorClick = Hi.HiCursorClick as ComponentType<IconProps>;
export const HiPhone = Hi.HiPhone as ComponentType<IconProps>;
export const HiViewGrid = Hi.HiViewGrid as ComponentType<IconProps>;
export const HiUserGroup = Hi.HiUserGroup as ComponentType<IconProps>;
export const HiCollection = Hi.HiCollection as ComponentType<IconProps>;
export const HiChevronRight = Hi.HiChevronRight as ComponentType<IconProps>;
export const HiLogout = Hi.HiLogout as ComponentType<IconProps>;
export const HiDocumentText = Hi.HiDocumentText as ComponentType<IconProps>;
export const HiClipboardCheck = Hi.HiClipboardCheck as ComponentType<IconProps>;
export const HiCalendar = Hi.HiCalendar as ComponentType<IconProps>;
export const HiSearch = Hi.HiSearch as ComponentType<IconProps>;
export const HiUpload = Hi.HiUpload as ComponentType<IconProps>;
export const HiPhotograph = Hi.HiPhotograph as ComponentType<IconProps>;
export const HiRefresh = Hi.HiRefresh as ComponentType<IconProps>;
export const HiXCircle = Hi.HiXCircle as ComponentType<IconProps>;
export const HiBadgeCheck = Hi.HiBadgeCheck as ComponentType<IconProps>;
export const HiExclamation = Hi.HiExclamation as ComponentType<IconProps>;
export const HiMenu = Hi.HiMenu as ComponentType<IconProps>;
export const HiChevronLeft = Hi.HiChevronLeft as ComponentType<IconProps>;
export const HiChevronDoubleLeft = Hi.HiChevronDoubleLeft as ComponentType<IconProps>;
export const HiChevronDoubleRight = Hi.HiChevronDoubleRight as ComponentType<IconProps>;
export const HiDotsVertical = Hi.HiDotsVertical as ComponentType<IconProps>;
export const HiEyeOff = Hi.HiEyeOff as ComponentType<IconProps>;
export const HiPlus = Hi.HiPlus as ComponentType<IconProps>;
export const HiMinus = Hi.HiMinus as ComponentType<IconProps>;
export const HiTrash = Hi.HiTrash as ComponentType<IconProps>;
export const HiShieldCheck = Hi.HiShieldCheck as ComponentType<IconProps>;
export const HiTruck = Hi.HiTruck as ComponentType<IconProps>;
export const HiCalculator = Hi.HiCalculator as ComponentType<IconProps>;
export const HiBell = Hi.HiBell as ComponentType<IconProps>;
export const HiShoppingBag = Hi.HiShoppingBag as ComponentType<IconProps>;
export const HiBriefcase = Hi.HiBriefcase as ComponentType<IconProps>;
export const HiMail = Hi.HiMail as ComponentType<IconProps>;
export const HiGlobeAlt = Hi.HiGlobeAlt as ComponentType<IconProps>;
export const HiPencil = Hi.HiPencil as ComponentType<IconProps>;
export const HiChevronDown = Hi.HiChevronDown as ComponentType<IconProps>;
export const HiChevronUp = Hi.HiChevronUp as ComponentType<IconProps>;
export const HiUsers = Hi.HiUsers as ComponentType<IconProps>;
export const HiKey = Hi.HiKey as ComponentType<IconProps>;
export const HiCheck = Hi.HiCheck as ComponentType<IconProps>;
export const HiInformationCircle = Hi.HiInformationCircle as ComponentType<IconProps>;
export const HiCog = Hi.HiCog as ComponentType<IconProps>;
export const HiDownload = Hi.HiDownload as ComponentType<IconProps>;
export const FaWhatsapp = Fa.FaWhatsapp as ComponentType<IconProps>;
